import validate from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/middleware/router.global.ts";
import manifest_45route_45rule from "/data/soft/jenkins/workspace/yolo_web_client-k8s-Pipeline-deploy/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}